// test1000
(1000 && 0);
